import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-060fcbec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-menu" }
const _hoisted_2 = ["onClick"]

import router from "@/router";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const routes = [
  {path: '/directives', name: 'Directives'},
  {path: '/methods', name: 'Methods'},
  {path: '/computed-properties', name: 'Computed properties'},
  {path: '/watchers', name: 'Watchers'},
  {path: '/props', name: 'Props basics'},
  {path: '/emit-events', name: 'Emit events'},
  {path: '/slots', name: 'Slots'},
  {path: '/hooks', name: 'Lifecycle hooks'},
  {path: '/animations', name: 'Animations'},
  {path: '/composition-api', name: 'Composition API'},
  {path: '/render-function', name: 'Render function'},
  {path: '/routing',name: 'Routing'},
  {path: '/vuex-basics', name: 'Vuex basics'},
  {path: '/testing',name: 'Testing'},
  {path: '/css-styles',name: 'Styles'},
  {path: '/examples',name: 'Examples'}
];

const sortedRoutes = routes.sort((a,b) => a.name.localeCompare(b.name));

const redirect = (routeName: string) => {
  router.push({name: routeName});
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedRoutes), (route) => {
      return (_openBlock(), _createElementBlock("li", {
        key: route.path,
        onClick: ($event: any) => (redirect(route.name))
      }, _toDisplayString(route.name), 9, _hoisted_2))
    }), 128))
  ]))
}
}

})